import { PrinterOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, ConfigProvider, Divider, Form, InputNumber, Row, Space, Table, Typography } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { hooks, models } from '@vote4dance/judging-sdk';
import { Loading } from '../../../../../base-react/components/Loading';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { RoundType } from '@vote4dance/judging-schema';
var Stream = hooks.streams.Stream;
var TeamSource = models.teams.TeamSource;
var TeamItem = models.teams.TeamItem;
var ClassesSource = models.classes.ClassesSource;
var CompetitionRoundSource = models.rounds.CompetitionRoundSource;
const { Title, Text } = Typography;
export const PrintStartNumber = () => {
    const { competition_id, team_start_number } = useParams();
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const [teams, loadingTeams] = Stream(TeamSource(competition_id));
    const [classes, loadingClasses] = Stream(ClassesSource(competition_id));
    const [rounds, loadingRounds] = Stream(CompetitionRoundSource(competition_id));
    const [settings, setSettings] = useState({
        showCompetition: true,
        showOrgSummary: true,
        showStartNumbers: true,
        sharedNumberPrints: true,
        selection: team_start_number ? 2 : 1,
        selectionTeams: team_start_number,
        selectionOrgs: ''
    });
    if (loadingTeams || loadingCompetition || loadingClasses || loadingRounds) {
        return React.createElement(Loading, null);
    }
    let result = teams ? [...teams].sort((a, b) => a.team_start_number < b.team_start_number ? -1 : 1) : [];
    // Shared or unique numbers
    if (settings.sharedNumberPrints) {
        result = [...result].filter((value, index, array) => array.map(a => a.team_start_number).indexOf(value.team_start_number) === index);
    }
    // Filter
    if (settings.selection == 1) {
        result = [...result].sort((a, b) => a.team_org < b.team_org ? -1 : 1);
        if (settings.selectionTeams) {
            result = [...result].filter(a => a.team_start_number.toString() == settings.selectionTeams);
        }
    }
    else if (settings.selection == 2) {
        result = [...result].filter(a => a.team_start_number.toString() == settings.selectionTeams);
        if (!result || result.length == 0) {
            result = [{
                    team_id: settings.selectionTeams,
                    team_start_number: parseInt(settings.selectionTeams),
                }];
        }
    }
    else if (settings.selection == 3) {
        result = [...result].filter(a => { var _a, _b; return ((_a = a.team_org_1) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === settings.selectionOrgs || ((_b = a.team_org) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === settings.selectionOrgs; });
    }
    // Add all numbers
    let printList = [];
    var lastOrg = "";
    result.forEach((model, index) => {
        // Add organizer page
        if (settings.showOrgSummary && settings.selection == 1 || settings.selection == 3) {
            var newOrg = model.team_org_1;
            var orgTeams = teams === null || teams === void 0 ? void 0 : teams.filter((a) => a.team_org_1 == newOrg);
            if (!newOrg) {
                newOrg = model.team_org;
                orgTeams = teams === null || teams === void 0 ? void 0 : teams.filter((a) => a.team_org == newOrg);
            }
            if (newOrg != lastOrg) {
                let activeTeams = orgTeams === null || orgTeams === void 0 ? void 0 : orgTeams.filter((a) => a.team_cancelled == 0);
                if (activeTeams && activeTeams.length > 0) {
                    printList.push(React.createElement(PrintStartNumberOrg, { key: newOrg + index, name: newOrg, teams: orgTeams, classes: classes, rounds: rounds, event: event, competition: inputCompetition, settings: settings }));
                }
                lastOrg = newOrg;
            }
        }
        if (settings.showStartNumbers && !model.team_cancelled) {
            printList.push(React.createElement(PrintStartNumberTeam, { key: model.team_id, team: model, allTeams: teams, classes: classes, rounds: rounds, isLast: index === result.length - 1, event: event, competition: inputCompetition, settings: settings }));
        }
    });
    return (React.createElement(ConfigProvider, { theme: {
            components: {
                Table: {
                    cellPaddingBlockSM: 0,
                    fontSize: 10
                },
            },
        } },
        React.createElement("style", { type: "text/css", media: "print" }, " @page { size: portrait; margin: 0 !important } "),
        React.createElement(PrintStartNumberSettings, { settings: settings, setSettings: setSettings }),
        printList));
};
const PrintStartNumberSettings = (props) => {
    const { settings, setSettings } = props;
    const onValuesChange = (values) => {
        setSettings({
            ...settings,
            ...values
        });
    };
    const onFinish = () => {
        window.print();
    };
    return (React.createElement(Row, { style: { width: '100%', paddingLeft: 30, backgroundColor: 'lightgrey' } },
        React.createElement("div", { className: "settings" },
            React.createElement("style", null, `@media print {.settings{display: none;}}`),
            React.createElement(Title, null, _T('common.print', { name: _T('team.details.team_start_number.label').toLowerCase() })),
            React.createElement(Form, { name: "printsettings", labelCol: { span: 8 }, wrapperCol: { span: 16 }, style: { maxWidth: 600 }, initialValues: settings, onValuesChange: onValuesChange, onFinish: onFinish, autoComplete: "off" },
                React.createElement(Form.Item, { name: "showCompetition", valuePropName: "checked", style: { marginBottom: 0 } },
                    React.createElement(Checkbox, null, _T('print.showCompetition'))),
                React.createElement(Form.Item, { name: "showOrgSummary", valuePropName: "checked", style: { marginBottom: 0 } },
                    React.createElement(Checkbox, null, _T('print.showOrgSummary'))),
                React.createElement(Form.Item, { name: "showStartNumbers", valuePropName: "checked", style: { marginBottom: 0 } },
                    React.createElement(Checkbox, null, _T('print.showStartNumbers'))),
                React.createElement(Form.Item, { name: "selectionTeams" },
                    React.createElement(InputNumber, null)),
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null), type: "primary", htmlType: "submit" }, _T('common.print')))))));
};
export const PrintStartNumberHeader = (props) => {
    const { event, competition, settings, overrideSettings, style } = props;
    return (React.createElement(Row, { wrap: false, justify: 'space-between', style: { width: '100%', height: 100, ...style } },
        React.createElement(Col, { flex: '100px' },
            React.createElement(Typography, null,
                React.createElement(Text, { strong: true }, "Vote4"),
                "Dance")),
        React.createElement(Col, { flex: 'auto' }, (overrideSettings || !settings || (settings === null || settings === void 0 ? void 0 : settings.showCompetition)) &&
            React.createElement(Typography, { style: { textAlign: 'center' } },
                React.createElement(Title, { style: { margin: 0 } }, competition === null || competition === void 0 ? void 0 : competition.competition_name),
                (competition === null || competition === void 0 ? void 0 : competition.competition_parent_id) &&
                    React.createElement(Title, { level: 2, type: "secondary", style: { margin: 0 } }, event === null || event === void 0 ? void 0 : event.competition_name),
                React.createElement(Text, null, event === null || event === void 0 ? void 0 : event.competition_organizer))),
        React.createElement(Col, { flex: '100px' }, (overrideSettings || !settings || (settings === null || settings === void 0 ? void 0 : settings.showCompetition)) &&
            React.createElement(Typography, { style: { textAlign: 'right' } },
                React.createElement(Text, null, competition === null || competition === void 0 ? void 0 : competition.competition_date)))));
};
const PrintStartNumberTeam = (props) => {
    const { team, allTeams, classes, rounds, isLast, event, competition, settings } = props;
    const sharedStartNumbers = allTeams === null || allTeams === void 0 ? void 0 : allTeams.filter(a => a.team_start_number === team.team_start_number);
    const columns = [
        {
            dataIndex: 'team_start_number',
            render: (text) => (React.createElement("div", { style: { fontSize: 14 } }, text))
        },
        {
            key: 'name',
            render: (text, item) => (React.createElement("div", { style: { fontSize: 14 } }, TeamItem.getFullNameWithOrg(item)))
        },
        {
            key: 'classes',
            render: (text, item) => {
                const classItem = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === item.class_id);
                if (!classItem) {
                    return null;
                }
                const classRounds = rounds ? rounds.filter(a => a.class_id === classItem.class_id && (parseInt(a.round_parent_id) == 0 || a.round_type == RoundType.Chance)) : [];
                return (React.createElement("div", { style: { fontSize: 14 } },
                    React.createElement("u", null, classItem.class_label),
                    React.createElement("br", null),
                    classRounds.map(round => (React.createElement(React.Fragment, { key: round.round_id },
                        React.createElement("span", null,
                            React.createElement("strong", null, (round.round_beat || '') + (round.floor_code ? round.floor_code : '')),
                            " ",
                            round.round_label),
                        React.createElement("br", null))))));
            }
        }
    ];
    return (React.createElement("div", { style: { margin: 24, pageBreakAfter: isLast ? 'inherit' : 'always' } },
        React.createElement(PrintStartNumberHeader, { event: event, competition: competition, settings: settings }),
        React.createElement(Row, { justify: 'center', style: { height: '310pt' } },
            React.createElement(Typography, null,
                React.createElement(Title, { level: 1, style: {
                        margin: 0,
                        fontSize: team.team_start_number.toString().length > 3 ? '200pt' : '250pt',
                        lineHeight: '250pt',
                        fontWeight: 800
                    } }, team.team_start_number || ''))),
        React.createElement(Divider, null),
        React.createElement(Title, { level: 3 }, team.team_org_1 ? team.team_org_1 : team.team_org),
        React.createElement("div", { style: { fontSize: '16px !important' } }, sharedStartNumbers && sharedStartNumbers.length > 0 && React.createElement(Table, { columns: columns, dataSource: sharedStartNumbers, pagination: false, showHeader: false, rowKey: 'team_id', size: 'small' }))));
};
const PrintStartNumberOrg = (props) => {
    const { name, teams, classes, rounds, event, competition, settings } = props;
    const columns = [
        {
            dataIndex: 'team_start_number',
            render: (text) => (React.createElement("div", { style: { fontSize: 14 } }, text))
        },
        {
            key: 'name',
            render: (text, item) => (React.createElement("div", { style: { fontSize: 14 } }, TeamItem.getFullNameWithOrg(item)))
        },
        {
            key: 'classes',
            render: (text, item) => {
                const classItem = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === item.class_id);
                if (!classItem) {
                    return null;
                }
                const classRounds = rounds ? rounds.filter(a => a.class_id === classItem.class_id && (parseInt(a.round_parent_id) == 0 || a.round_type == RoundType.Chance)) : [];
                const roundFloorBeats = classRounds.filter(a => a.round_beat).map(a => a.round_beat + (a.floor_code || ''));
                return (React.createElement("div", { style: { fontSize: 14 } },
                    React.createElement(Space, null,
                        classItem.class_label,
                        roundFloorBeats.length > 0 &&
                            React.createElement("strong", null,
                                "(",
                                roundFloorBeats.join(', '),
                                ")"))));
            }
        }
    ];
    return (React.createElement("div", { style: { margin: 24, pageBreakAfter: 'always' } },
        React.createElement(PrintStartNumberHeader, { event: event, competition: competition, settings: settings, overrideSettings: true }),
        React.createElement(Title, { level: 1 }, name),
        React.createElement(Table, { columns: columns, dataSource: teams, pagination: false, showHeader: false, rowKey: 'team_id', size: 'small' })));
};
